import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Slider extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [
        {
          title: 'default',
          isDefault: true,
        },
      ],
      modifiers : [],
      states : []
    }

    this.state = {
      sliderValue: this.props.value || 0,
      isDisabled : this.props.disabled
    };

    this.handleChange = this.handleChange.bind(this)
  }
  
  handleChange(event) { 
    let value = event.target.value;
    this.setState({
      sliderValue: value
    });
  }

  renderPercentage(min, max) { 
    let percentage = (this.state.sliderValue-min)*100/(max-min);
    return percentage
  }

  renderSlider(props, step, min, max, onChange, disabled) { 
    const sliderValueBar = this.renderPercentage(min,max, this.state.sliderValue)+"%";
    return <div className="mdn-Slider-contentBar">
      <span className="mdn-Slider-barRange" style={{width:sliderValueBar}}></span>
      <input
        {...props}
        className="mdn-Slider-bar" 
        type="range" 
        value={this.state.sliderValue} 
        step={step} 
        min={min} 
        max={max} 
        disabled={disabled}
        onChange={(evt)=>{
          this.handleChange(evt);
          onChange(evt, event.target.value);
        }}/>
    </div>
  }

  render() {
    let { onChange, min, max, value, step, disabled, ...rest } = this.props
    const props = clearProps(this.props)
    min = min || 0
    max = max || 100
    step = step || 1
    value = value || min
    onChange = onChange || function(){}
    
    const sliderValuePercentage = this.renderPercentage(min,max, this.state.sliderValue)+"%";
    return  <div className={resolveProps(this.props, this.config, 'Slider') + ' ' + this.parentClassName} disabled={disabled}>
      <div className="mdn-Slider-percent">
        <p className="mdn-Slider-percentText mdn-Heading" style={{
          left:sliderValuePercentage,
          transform:`translateX(-${sliderValuePercentage})`
        }}>{this.state.sliderValue}</p>
        <p className="mdn-Slider-percentText--init mdn-Heading">{min}</p>
        <p className="mdn-Slider-percentText--final mdn-Heading">{max}</p> 
      </div>
      {this.renderSlider(props, step, min, max, onChange, disabled)}
    </div>
  }
}

Slider.propTypes = {
  config : PropTypes.object,
  min : PropTypes.number,
  max : PropTypes.number,
  value : PropTypes.number,
  step : PropTypes.number,
  disabled: PropTypes.bool
}
